/* jshint ignore:start */

var BulletinsManager = (function($) {

    var instance;

    function init() {

        var _$bulletinFilter;
        var _$bulletinDownloadFilter;

        function hasDataToFilter()
        {
            var category = $('.js-bulletin-category').val();

            if (category != 0) {
                return true;
            }

            return false;
        }

        function getSubCategoriesFromGlobal(categorySlug)
        {
            var item;
            var numCategories = CUSTOM_DATA.bulletinCategories.length;

            if (numCategories) {
                for (var i = 0; i < numCategories; i++) {
                    item = CUSTOM_DATA.bulletinCategories[i];
                    if (item.slug == categorySlug) {
                        return item.categories;
                    }
                }
            }

            return null;
        }

        function getSubCategoriesOptions(categorySlug)
        {
            var optionsHtml = '<option value="0">Subcategorías</option>';

            var subCategories = getSubCategoriesFromGlobal(categorySlug);

            if (subCategories) {
                var item;
                var numSubCategories = subCategories.length;
                for (var i = 0; i < numSubCategories; i++) {
                    item = subCategories[i];
                    optionsHtml += '<option value="'+ item.slug +'">'+ item.name +'</option>';
                }
            }

            return optionsHtml;
        }

        function initFilterBulletin()
        {
            var $bulletinFilterBtn = $('.js-filter-bulletin-btn');
            $bulletinFilterBtn.on('click', function(e) {
                e.preventDefault();

                var url = _$bulletinFilter.data('url');

                if (hasDataToFilter()) {

                    var category = $('.js-bulletin-category').val();
                    var subCategory = $('.js-bulletin-subcategory').val();

                    if (subCategory != 0) {
                        url += '/'+ subCategory;
                    } else if(category != 0) {
                        url += '/'+ category;
                    }
                } else {
                    url += '/ver-todas';
                }

                _$bulletinFilter.attr('action', url);
                _$bulletinFilter.submit();

            });


            var $bulletinCategoryFilter = $('.js-bulletin-category');
            $bulletinCategoryFilter.on('change', function(e) {
                var categorySlug = $(this).val();

                $('.js-bulletin-subcategory').empty().append(getSubCategoriesOptions(categorySlug));
            });

            var $bulletinWordFilter = $('.js-bulletin-word');
            $bulletinWordFilter.on('keyup', function(e) {
                if (e.keyCode === 13) {
                    // Cancel the default action, if needed
                    e.preventDefault();
                    // Trigger the button element with a click

                    var url = _$bulletinFilter.data('url');

                    if (hasDataToFilter()) {

                        var category = $('.js-bulletin-category').val();
                        var subCategory = $('.js-bulletin-subcategory').val();

                        if (subCategory != 0) {
                            url += '/'+ subCategory;
                        } else if(category != 0) {
                            url += '/'+ category;
                        }
                    } else {
                        url += '/ver-todas';
                    }

                    _$bulletinFilter.attr('action', url);
                    _$bulletinFilter.submit();
                }
            });


        }

        function resetBulletinsDownload($items, hideClass)
        {
            var $item;
            var idx = 0;
            $items.each(function () {
                $item = $(this);

                if (idx < 3) {
                    $item.removeClass(hideClass)
                } else {
                    if (!$item.hasClass(hideClass)) {
                        $item.addClass(hideClass);
                    }
                }

                idx++;
            });

        }
        function filterDownloadBulletins()
        {
            var year = _$bulletinDownloadFilter.find('.js-bulletin-download-year').val();
            var month = _$bulletinDownloadFilter.find('.js-bulletin-download-month').val();

            var $item;
            var currentMonth;
            var currentYear;

            var hideClass = 'd-none';

            var $items = $('.js-bulletin-downlowad');

            if (month == '0' && year == '0') {
                resetBulletinsDownload($items, hideClass);
            } else {
                $items.each(function () {
                    $item = $(this);
                    currentMonth = $item.data('month');
                    currentYear = $item.data('year');
                    if (year != '0' && month != '0') {
                        if (year == currentYear && month == currentMonth) {
                            $item.removeClass(hideClass)
                        } else {
                            if (!$item.hasClass(hideClass)) {
                                $item.addClass(hideClass);
                            }
                        }
                    } else {
                        if (year != '0') {
                            if (year == currentYear) {
                                $item.removeClass(hideClass)
                            } else {
                                if (!$item.hasClass(hideClass)) {
                                    $item.addClass(hideClass);
                                }
                            }
                        } else {
                            if (month == currentMonth) {
                                $item.removeClass(hideClass)
                            } else {
                                if (!$item.hasClass(hideClass)) {
                                    $item.addClass(hideClass);
                                }
                            }
                        }
                    }
                });
            }



        }

        function initFilterBulletinDownload()
        {
            var $bulletinFilterBtn = $('.js-form-bulletins-download-btn');
            $bulletinFilterBtn.on('click', function(e) {
                e.preventDefault();


                filterDownloadBulletins();
            });
        }

        return {

            init: function() {

                _$bulletinFilter = $('.js-form-filter-bulletin');

                if (_$bulletinFilter.length) {
                    initFilterBulletin();
                }

                _$bulletinDownloadFilter = $('.js-form-bulletins-download');
                if (_$bulletinDownloadFilter.length) {
                    initFilterBulletinDownload();
                }
            }
        };
    }


    return {

        getInstance: function() {

            if (!instance) {
                instance = init();
            }

            return instance;
        }
    };
})(jQuery);
/* jshint ignore:end */
